"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _text = require("./text.tokens");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Text = _interopRequireDefault(require("./Text"));
var _FlexItem = require("../layout/flex/FlexItem");
var _jsxRuntime = require("react/jsx-runtime");
var StyledLabel = _styledComponents.default.label.withConfig({
  displayName: "Label__StyledLabel",
  componentId: "sc-em9x30-0"
})(["display:inline-block;", ";color:", ";cursor:inherit;white-space:", ";"], function (props) {
  return props.theme.sys.font.label['1'];
}, function (_ref) {
  var color = _ref.color;
  return _text.tokens.color.labels[color];
}, function (_ref2) {
  var noWrap = _ref2.noWrap;
  return noWrap ? 'nowrap' : 'pre-wrap';
});
var Label = function Label(_ref3) {
  var children = _ref3.children,
    color = _ref3.color,
    noWrap = _ref3.noWrap,
    isOptional = _ref3.isOptional,
    props = _objectWithoutProperties(_ref3, ["children", "color", "noWrap", "isOptional"]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FlexItem.FlexItem, {
    gap: 'xs',
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLabel, _objectSpread({
      color: color,
      noWrap: noWrap
    }, props, {
      children: children
    })), isOptional ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
      color: "medium",
      children: "(Optional)"
    }) : null]
  });
};
var _default = exports.default = Label;
Label.defaultProps = {
  color: 'default',
  isOptional: false,
  noWrap: false
};